import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ContactUs from './pages/ContactUs';
import About from './pages/About';
import Applications from './pages/Applications';
import Industries from './pages/Industries';
import ApplicationModernization from './pages/services/ApplicationModernization';
import ApplicationSecurity from './pages/services/ApplicationSecurity';
import OracleApplicationServices from './pages/services/OracleApplicationServices';
import DevOpsServices from './pages/services/DevOpsServices';
import SAPApplicationServices from './pages/services/SAPApplicationServices';
import CloudMigration from './pages/services/CloudMigration';
import DataAndAI from './pages/services/DataAndAI';
import CloudServices from './pages/services/CloudServices';
import DigitalWorkplace from './pages/services/DigitalWorkplace';
import Consulting from './pages/services/Consulting';
// Industry pages
import Insurance from './pages/industries/Insurance';
import Automotive from './pages/industries/Automotive';
import Manufacturing from './pages/industries/Manufacturing';
import Retail from './pages/industries/Retail';
import CommunicationMedia from './pages/industries/CommunicationMedia';
import TravelTransportation from './pages/industries/TravelTransportation';
import Utilities from './pages/industries/Utilities';
import Healthcare from './pages/industries/Healthcare';
import BankingFinancial from './pages/industries/BankingFinancial';
import ChemicalOilGas from './pages/industries/ChemicalOilGas';
import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about" element={<About />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/applications/modernization" element={<ApplicationModernization />} />
          <Route path="/applications/security" element={<ApplicationSecurity />} />
          <Route path="/applications/oracle-services" element={<OracleApplicationServices />} />
          <Route path="/applications/devops" element={<DevOpsServices />} />
          <Route path="/applications/sap-services" element={<SAPApplicationServices />} />
          <Route path="/applications/cloud-migration" element={<CloudMigration />} />
          <Route path="/data-ai" element={<DataAndAI />} />
          <Route path="/cloud" element={<CloudServices />} />
          <Route path="/digital-workplace" element={<DigitalWorkplace />} />
          <Route path="/consulting" element={<Consulting />} />
          {/* Industry routes */}
          <Route path="/industries/insurance" element={<Insurance />} />
          <Route path="/industries/automotive" element={<Automotive />} />
          <Route path="/industries/manufacturing" element={<Manufacturing />} />
          <Route path="/industries/retail" element={<Retail />} />
          <Route path="/industries/communication-and-media" element={<CommunicationMedia />} />
          <Route path="/industries/travel-transportation" element={<TravelTransportation />} />
          <Route path="/industries/utilities" element={<Utilities />} />
          <Route path="/industries/healthcare" element={<Healthcare />} />
          <Route path="/industries/banking-and-financial-markets" element={<BankingFinancial />} />
          <Route path="/industries/chemical-oil-gas" element={<ChemicalOilGas />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
